module.exports = __webpack_public_path__ + "img/login.a09cd317.png";